// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1ukOINMLm8cSrE {\n  margin: 8px 0 0 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clearButton": "_1ukOINMLm8cSrE"
};
export default ___CSS_LOADER_EXPORT___;
